import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * 线缆测温接口
 **********************************************************************************/
export default {
	/**
	 * 获取单位下线缆测温点树
	 */
	getCableAndPointTree:(unitId,success, failure) => {
		Axios.post('/cable/getCableAndPointTree.do', {
			unitId
		}, success, failure);
	},
	/**
	 * 添加或更新线缆
	 */
	saveCable:(pkid,name,address,type,content,sort,unitId,success, failure) => {
		Axios.post('/cable/saveCable.do', {
			pkid,
			name,
			address,
			type,
			content,
			sort,
			unitId,
		}, success, failure);
	},
	/**
	 * 删除线缆以及线缆下测温点
	 */
	deleteCable:(pkids,success, failure) => {
		Axios.post('/cable/deleteCable.do', {
			pkids,
		}, success, failure);
	},
   /**
	 * 添加或更新测温点
	 */
	saveTemperatureMeasuringPoint:(pkid,name,address,latitudeAndLongitude,deviceNo,variableName,variableType,sort,cableId,remarks,success, failure) => {
		Axios.post('/cable/saveTemperatureMeasuringPoint.do', {
			pkid,
			name,
			address,
			latitudeAndLongitude,
			deviceNo,
			variableName,
			variableType,
			sort,
			cableId,
			remarks,
		}, success, failure);
	},
	/**
	 * 删除测温点
	 */
	deleteTemperatureMeasuringPoint:(pkids,success, failure) => {
		Axios.post('/cable/deleteTemperatureMeasuringPoint.do', {
			pkids,
		}, success, failure);
	},
	/**
	 * 分页获取单位下线缆列表
	 */
	getCableLimit:(unitId,pageIndex,pageSize,success, failure) => {
		Axios.post('/cable/getCableLimit.do', {
			unitId,
			pageIndex,
			pageSize,
		}, success, failure);
	},
	/**
	 * 分页获取线缆下测温点列表
	 */
	getPointLimitByCableId:(cableId,pageIndex,pageSize,success, failure) => {
		Axios.post('/cable/getPointLimitByCableId.do', {
			cableId,
			pageIndex,
			pageSize,
		}, success, failure);
	},
}
